import _get from 'lodash/get'

import {
    INVESTMENT_SCHEMES_SAVE_ERROR,
    INVESTMENT_SCHEMES_SAVE_SUCCESS,
    INVESTMENT_SCHEMES_SAVING,
    INVESTMENT_SCHEMES_UPDATE,
} from '../actions'

export default (
    state = {
        shouldFetch: true,
        goToNextQuestion: false,
        goToNextAllowanceQuestion: false,
        isAllowanceUpdate: false,
        activeQuestionIndex: 0,
    },
    action
) => {
    switch (action.type) {
        case INVESTMENT_SCHEMES_UPDATE:
            return { ...state, ...action.investmentSchemes }

        case INVESTMENT_SCHEMES_SAVING:
            return { ...state, isSaving: true }

        case INVESTMENT_SCHEMES_SAVE_SUCCESS:
            return {
                ...state,
                ...action.investmentSchemes,
                isSaving: false,
                goToNextQuestion: !action.investmentSchemes.isAllowanceUpdate,
                goToNextAllowanceQuestion: action.investmentSchemes.isAllowanceUpdate,
                isAllowanceUpdate: false,
                saveError: false,
                errorMessage: '',
                validationErrors: null,
            }

        case INVESTMENT_SCHEMES_SAVE_ERROR:
            return {
                ...state,
                ...action.investmentSchemes,
                isSaving: false,
                goToNextQuestion: false,
                goToNextAllowanceQuestion: false,
                saveError: true,
                errorMessage: _get(action, ['errorResponse', 'message'], 'Unknown error occurred'),
                validationErrors: _get(action, ['errorResponse', 'modelState'], false),
            }

        default:
            return state
    }
}
